import React from "react";
import OTLayout from "./OTLayout";
import { THEATRES, SCHEDULE_HOURS, SCHEDULE_SLOTS } from "./mockData";
import {
  OtPage,
  SectionCard,
  SLOT_TONES,
  Box,
  Typography,
  Stack,
  eyebrowSx,
  titleSx,
  subtitleSx,
} from "./ui";
import { C } from "./constants";

function todayLabel() {
  return new Date().toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
}

export default function OTSchedule() {
  return (
    <OTLayout activeNav="schedule">
      <OtPage>
        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} spacing={1.5} sx={{ mb: 2.5 }}>
          <Box>
            <Typography sx={eyebrowSx}>{todayLabel()}</Typography>
            <Typography component="h1" sx={titleSx}>OT schedule</Typography>
            <Typography sx={subtitleSx}>Live view across the four operating theatres.</Typography>
          </Box>
          <Stack direction="row" spacing={1.75} sx={{ fontSize: 12, color: C.textSub, alignItems: "center" }}>
            {Object.entries(SLOT_TONES).map(([type, tone]) => (
              <Stack key={type} direction="row" alignItems="center" spacing={0.75}>
                <Box sx={{ width: 10, height: 10, borderRadius: "2px", bgcolor: tone.bg, border: `1px solid ${tone.border}` }} />
                <Typography sx={{ fontSize: 12, color: C.textSub }}>
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>

        <SectionCard sx={{ overflow: "auto" }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: `100px repeat(${SCHEDULE_HOURS.length}, minmax(80px, 1fr))`,
              minWidth: 900,
            }}
          >
            <Box sx={{ p: "10px 12px", borderBottom: `1px solid ${C.border}`, borderRight: `1px solid ${C.border}`, bgcolor: "#f8f9fa", fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: C.textSub }}>
              Theatre
            </Box>
            {SCHEDULE_HOURS.map((h) => (
              <Box key={h} sx={{ p: "10px 8px", borderBottom: `1px solid ${C.border}`, bgcolor: "#f8f9fa", textAlign: "center", fontSize: 12, fontWeight: 600, color: C.textSub }}>
                {h}
              </Box>
            ))}

            {THEATRES.map((ot) => (
              <React.Fragment key={ot}>
                <Box sx={{ p: 1.5, borderBottom: `1px solid ${C.border}`, borderRight: `1px solid ${C.border}`, fontSize: 13, fontWeight: 600 }}>
                  {ot}
                </Box>
                <Box
                  sx={{
                    gridColumn: `2 / span ${SCHEDULE_HOURS.length}`,
                    borderBottom: `1px solid ${C.border}`,
                    position: "relative",
                    minHeight: 80,
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "grid",
                      gridTemplateColumns: `repeat(${SCHEDULE_HOURS.length}, minmax(0, 1fr))`,
                    }}
                  >
                    {SCHEDULE_HOURS.map((_, i) => (
                      <Box key={i} sx={{ borderLeft: i > 0 ? `1px solid ${C.border}` : "none", opacity: 0.5 }} />
                    ))}
                  </Box>
                  <Box
                    sx={{
                      position: "relative",
                      display: "grid",
                      gridTemplateColumns: `repeat(${SCHEDULE_HOURS.length}, minmax(0, 1fr))`,
                      gap: 0.5,
                      p: 0.5,
                      height: "100%",
                    }}
                  >
                    {SCHEDULE_SLOTS.filter((s) => s.ot === ot).map((s, i) => {
                      const tone = SLOT_TONES[s.type];
                      return (
                        <Box
                          key={i}
                          sx={{
                            gridColumn: `${s.start + 1} / span ${s.span}`,
                            borderRadius: "8px",
                            border: `1px solid ${tone.border}`,
                            bgcolor: tone.bg,
                            color: tone.color,
                            p: "6px 8px",
                            fontSize: 11,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          <Typography sx={{ fontWeight: 700, fontSize: 11, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {s.label}
                          </Typography>
                          <Typography sx={{ opacity: 0.85, fontSize: 11, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {s.surgeon}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </React.Fragment>
            ))}
          </Box>
        </SectionCard>
      </OtPage>
    </OTLayout>
  );
}
